/* eslint-disable prefer-template */
import { create } from 'xmlbuilder2';

import { gpxType, metadataType, wptType, rteType, trkType } from '@/lib/gpx/gpxModel';

const GPX_VERSION = '1.1';

const NS_DEFAULT = 'http://www.topografix.com/GPX/1/1';
const NS_XSI = 'http://www.w3.org/2001/XMLSchema-instance';

const XSI_LOC = "http://www.topografix.com/GPX/1/1 http://www.topografix.com/GPX/1/1/gpx.xsd";

export interface IGPXBuilder {
  gpx: gpxType;
  setMetadata: (metadata: metadataType) => void;
  addWaypoint: (wpt: wptType) => void;
  addWaypoints: (wpts: Array<wptType>) => void;
  addRoute: (rte: rteType) => void;
  addRoutes: (rtes: Array<rteType>) => void;
  addTrack: (trk: trkType) => void;
  addTracks: (trks: Array<trkType>) => void;
  writeGPX: () => string;
}


class GPXBuilder implements IGPXBuilder {
  gpx: gpxType;

  constructor(creator: string) {
    this.gpx = {
      '@xmlns': NS_DEFAULT,
      '@xmlns:xsi': NS_XSI,
      '@xsi:schemaLocation': XSI_LOC,
      '@version': GPX_VERSION,
      '@creator': creator
    }
  }

  setMetadata(metadata: metadataType) {
    this.gpx.metadata = metadata;
  }

  addWaypoint(wpt: wptType) {
    if (!this.gpx.wpt) {
      this.gpx.wpt = [wpt];
    } else {
      this.gpx.wpt.push(wpt);
    }
  }

  addWaypoints(wpts: Array<wptType>) {
    if (!this.gpx.wpt) {
      this.gpx.wpt = wpts;
    } else {
      this.gpx.wpt = this.gpx.wpt.concat(wpts);
    }
  }

  addRoute(rte: rteType) {
    if (!this.gpx.rte) {
      this.gpx.rte = [rte];
    } else {
      this.gpx.rte.push(rte);
    }
  }

  addRoutes(rtes: Array<rteType>) {
    if (!this.gpx.rte) {
      this.gpx.rte = rtes;
    } else {
      this.gpx.rte = this.gpx.rte.concat(rtes);
    }
  }

  addTrack(trk: trkType) {
    if (!this.gpx.trk) {
      this.gpx.trk = [trk];
    } else {
      this.gpx.trk.push(trk);
    }
  }

  addTracks(trks: Array<trkType>) {
    if (!this.gpx.trk) {
      this.gpx.trk = trks;
    } else {
      this.gpx.trk = this.gpx.trk.concat(trks);
    }
  }
 
  writeGPX() {

    const root = create({version: '1.0', encoding: 'UTF-8'}, { gpx: this.gpx });

    const xml = root.end({ prettyPrint: true});
    console.log(xml);

    // const xml = `<gpx xmlns="${NS_DEFAULT}" xmlns:xsi="${NS_XSI}" version="${this.gpx.version}" creator="${this.gpx.creator}">
    //  ${this.gpx.metadata ? this.writeMetaData(this.gpx.metadata) : ''}
    //  ${Array.isArray(this.gpx.wpt) && this.gpx.wpt.length > 0 ? '' : ''}
    //  </gpx>`
    //   ;

    return xml;
  }
}

export default GPXBuilder;